import {
  Tabs,
  Tab,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Button,
} from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import SearchBar from "../../components/SearchBar";
import { showError, showToast } from "../../helpers/showToast";
import ApprovedDealersList from "../../features/dealers/approvedDealersList";
import NewDealersList from "../../features/dealers/newDealerstList";
import RejectedDealersList from "../../features/dealers/rejectedDealersList";
import MainContainer from "../../layout/MainContainer";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import ResonOfRejection from "../../Modals/reasonOfRejection";
import {
  useLazyDeleteUserQuery,
  useLazyGetUsersQuery,
  useUpdateUserProfileMutation,
} from "../../service/auth";
// import { useLazyGetAddListingQuery } from '../../service/listing';
import { CommonBody, Users } from "../../types/General";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { APPROVAL_STATUS, UPDATE_TYPES, USER_TYPE } from "../../utils/enums";
import { isValidInput } from "../../utils/validations";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Dealers = () => {
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs, setValueTabs] = useState(APPROVAL_STATUS.PENDING);
  const [newUsers, setNewUsers] = useState<number>(0);
  const [approvedUsers, setApprovedUsers] = useState<number>(0);
  const [rejectedUsers, setRejectedUsers] = useState<number>(0);
  const [selectedId, setSelectedId] = useState("");
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  // const [getAddListing] = useLazyGetAddListingQuery();
  const [getUsers] = useLazyGetUsersQuery();
  const [deleteUser] = useLazyDeleteUserQuery();
  const [updateUser] = useUpdateUserProfileMutation();

  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<Users[]>([]);
  const [page, setPage] = useState<number>(1);
  const [rejectionRsn, setRejectionRsn] = useState<string>("");
  const [rejectionOpen, setRejectionOpen] = useState<boolean>(false);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);

  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: string
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId("");
  };

  const columns: GridColDef<(typeof users)[number]>[] = [
    {
      flex: 0.8,
      minWidth: 200,
      field: "name",
      headerName: "Owner Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/profile-detail/dealer/${row?._id}`)}
            >
              <img
                src={row?.image || "/static/images/user_placeholder.png"}
                alt=""
              />
            </figure>
            <p>
              <b>{row?.name || "-"}</b>
              {row?.dialCode} {row?.phoneNo || "-"} <br />
              {row?.email || "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 300,
      field: "address",
      headerName: "Address",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.addressObject?.address || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row._id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setModalType("accept");
                      setAnchorEl1(null);
                      setOpen(true);
                    }
                  }}
                >
                  Approve
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    if (selectedId) {
                      setRejectionOpen(true);
                      setAnchorEl1(null);
                      setModalType("reject");
                      // setOpen(true);
                    }
                  }}
                >
                  Reject
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    navigate(`/profile-detail/dealer/${selectedId}`)
                  }
                >
                  View
                </MenuItem>
                <MenuItem
                  onClick={() =>
                    navigate(`/edit-profile-detail/dealer/${selectedId}`)
                  }
                >
                  Edit
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      const response = await deleteUser({
        id: selectedId,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        showToast("Deleted successfully");
        getUsersList();
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleUserUpdate = async (id: string, status: any, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { isBlocked: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateUser({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        const updatedData = users?.map((item) => {
          if (item?._id === id) {
            return {
              ...item,
              isBlocked: status,
            };
          }
          return item;
        });
        setUsers(updatedData);
        if (status === true) {
          showToast("Blocked successfully");
        } else {
          showToast("Unblocked successfully");
        }
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handleApproveReject = async () => {
    setRejectionOpen(false);
    const body = {
      status: modalType === "accept" ? 2 : 3,
      ...(modalType === "reject" && { rejectionReason: rejectionRsn }),
    };
    setRejectionRsn("");

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateUser({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();
      if (response?.statusCode === 200) {
        showToast(
          modalType === "accept"
            ? "Dealer approved successfully"
            : "Dealer rejected successfully"
        );
        if (modalType === "accept") {
          setValueTabs(APPROVAL_STATUS.APPROVED);
          setPage(1);
        } else {
          setValueTabs(APPROVAL_STATUS.REJECTED);
          setPage(1);
        }
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      console.error(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const getUsersList = async () => {
    setLoading(true);
    try {
      const response = await getUsers({
        page: page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        role: USER_TYPE.DEALER,
        status: valueTabs + 1,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setUsers(response?.data?.user || []);
        setCount(response?.data?.count);
        setNewUsers(response?.data?.pendingCount);
        setApprovedUsers(response?.data?.approvedCount);
        setRejectedUsers(response?.data?.rejectCount);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getUsersList();
  }, [debouncedSearchTerm, page, valueTabs]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1> Dealers</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Registrations - Dealers
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search dealers"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab
              label={`New Dealers (${newUsers})`}
              {...a11yProps(APPROVAL_STATUS.PENDING)}
            />
            <Tab
              label={`Approved Dealers (${approvedUsers})`}
              {...a11yProps(APPROVAL_STATUS.APPROVED)}
            />
            <Tab
              label={`Rejected Dealers(${rejectedUsers})`}
              {...a11yProps(APPROVAL_STATUS.REJECTED)}
            />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.PENDING}>
            <NewDealersList
              rows={users}
              columns={columns}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.APPROVED}>
            <ApprovedDealersList
              count={count}
              rows={users}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setUsers={setUsers}
              setSelectedId={setSelectedId}
              handleDeleteUser={handleDeleteUser}
              handleUserUpdate={handleUserUpdate}
              setModalType={setModalType}
              setOpen={setOpen}
              selectedId={selectedId}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={APPROVAL_STATUS.REJECTED}>
            <RejectedDealersList
              count={count}
              rows={users}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
              setSelectedId={setSelectedId}
              selectedId={selectedId}
              setOpen={setOpen}
              setModalType={setModalType}
            />
          </CustomTabPanel>
        </Box>

        <ResonOfRejection
          selectedId={selectedId}
          rejectionRsn={rejectionRsn}
          setRejectionRsn={setRejectionRsn}
          open={rejectionOpen}
          setOpen={setRejectionOpen}
          onClose={handleApproveReject}
        />

        <ConfirmationModal
          text={
            modalType === "delete"
              ? "Are you sure to delete this dealer?"
              : modalType === "accept"
                ? "Are you sure to approve this dealer?"
                : modalType === "reject"
                  ? "Are you sure to reject this dealer?"
                  : ""
          }
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={
            modalType === "delete"
              ? handleDeleteUser
              : modalType === "accept" || modalType === "reject"
                ? () => handleApproveReject()
                : () => {}
          }
        />
      </div>
    </MainContainer>
  );
};

export default Dealers;
